import { AgGridReact } from "@ag-grid-community/react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { Button, } from "antd";
import { vsmCommon } from "../../../../config/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { default_roles } from "../../../../utils/GlobalFunction";
import ServerGridConfig from "../../../../config/ServerGridConfig";

const ActionRenderer = observer((props) => {
	const { AUTH } = useStore();
	const { openViewModal } = props.agGridReact.props.frameworkComponents;

	return (
		<div className="action-column">
			{AUTH.checkPrivileges("#3310#") && (
				<Button
					type="text"
					className="viewIcon"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openViewModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faEye} />
				</Button>
			)}
		</div>
	);
});

const ListComponent = observer((props) => {
	const { openViewModal } = props;
	const {
		SuccessfulInquiriesStore: { setupGrid },
		AUTH
	} = useStore();

	const gridOptions = {
		columnDefs: [
			{
				headerName: "# ID",
				field: "id",
				filter: "agNumberColumnFilter",
				pinned: "left",
				minWidth: 120,
				width: 120,
			},
			{
				headerName: "Code",
				field: "code",
			},
			{
				headerName: "Inquiry Id",
				field: "mfg_code",
			},
			{
				headerName: "Opened On",
				field: "date",
				filter: 'agDateColumnFilter',
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
				},
			},
			{
				headerName: "Closed On",
				field: "closure_date",
				filter: 'agDateColumnFilter',
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
				},
			},
			{
				headerName: "Order No",
				field: "mfg_booking_code",
			},
			{
				headerName: "Customer",
				field: "full_name",

			},
			{
				headerName: "Phone",
				field: "phone",
				hide: [default_roles.admin].includes(AUTH?.user?.role_id) ? false : true,
			},
			{
				headerName: "Model",
				field: "model.name",
			},
			{
				headerName: "Variant",
				field: "variant.name",
			},
			{
				headerName: "Consultant",
				field: "sales_consultant.name",
			},
			{
				headerName: "Reporting To",
				field: "sales_consultant.reporting_to.name",
				valueGetter: (params) =>
					params.data && params.data.sc_id === null ? "N/A" : params.data?.sales_consultant.reporting_to.name,
			},
			{
				headerName: "Location",
				field: "location.name",
			},
			{
				headerName: "Customer Type",
				field: "customer_type.name",
			},
			{
				headerName: "Test Drive",
				field: "test_drive",
				filter: false,
			},
			{
				headerName: "Exchange",
				field: "exchange",
				filter: false,
			},
			{
				headerName: "Resale",
				field: "resale",
				filter: false,
			},
			{
				headerName: "Finance",
				field: "finance",
			},
			{
				headerName: "Receptionist",
				field: "receptionist.name",
				filter: false,
			},
			{
				headerName: "Days Opened",
				field: "days_opened",
				filter: "agNumberColumnFilter",
			},
			{
				headerName: "Actions",
				field: "actions",
				type: "actionColumn",
				filter: false,
				sortable: false,
				pinned: "right",
				minWidth: 180,
				width: 180,
			},
		],
	};
	return (
		// <div className="ag-theme-alpine grid_wrapper">
		// 	<AgGridReact
		// 		rowHeight={LocalGridConfig.rowHeight}
		// 		headerHeight={LocalGridConfig.headerHeight}
		// 		rowData={list_data}
		// 		modules={AllModules}
		// 		columnDefs={gridOptions.columnDefs}
		// 		defaultColDef={LocalGridConfig.defaultColDef}
		// 		columnTypes={LocalGridConfig.columnTypes}
		// 		overlayNoRowsTemplate={vsmCommon.noRecord}
		// 		frameworkComponents={{ ActionRenderer, openViewModal }}
		// 		onGridReady={setupGrid}
		// 		gridOptions={LocalGridConfig.options}
		// 		onFilterChanged={onFilterChanged}
		// 		onSortChanged={onFilterChanged}
		// 	/>
		// </div>
		<div className="ag-theme-alpine grid_wrapper">
			<AgGridReact
				rowHeight={ServerGridConfig.rowHeight}
				headerHeight={ServerGridConfig.headerHeight}
				modules={AllModules}
				columnDefs={gridOptions.columnDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={vsmCommon.noRecord}
				frameworkComponents={{ ActionRenderer, openViewModal }}
				onGridReady={setupGrid}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
});

export default ListComponent;
